import { Component, OnInit } from "@angular/core";

import { tap } from "rxjs/operators";

import { MessageService } from "primeng/components/common/messageservice";

import { Contrato } from "../../base/vo/contrato";
import { AdminContratosService } from "./admin-contratos.service";

@Component({
  selector: "app-admin-contratos",
  templateUrl: "./admin-contratos.component.html",
  styleUrls: ["./admin-contratos.component.scss"],
})
export class AdminContratosComponent implements OnInit {

  constructor(
    public adminContratosService: AdminContratosService,
    public messageService: MessageService
  ) {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos.component.ts